exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#module-content-container .v-overlay__content{padding-left:80px;width:100%;height:100%}#module-content-container .v-overlay__content .v-overlay__scrim{border-radius:0}", ""]);

// exports
